module.exports = __webpack_public_path__ + "31c7566786752ba11c52a4f89654adf7.svg";